"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/strings"),
    asciiLowercase = _require.asciiLowercase;

var _require2 = require("../helpers/traversal"),
    closest = _require2.closest;

function reflectedAttributeClampedToRange(attrValue, min, max) {
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (attrValue === null) {
    return defaultValue;
  } // We don't allow hexadecimal numbers here.
  // eslint-disable-next-line radix


  var parsed = parseInt(attrValue, 10);

  if (isNaN(parsed) || parsed < 0) {
    return defaultValue;
  }

  if (parsed < min) {
    return min;
  }

  if (parsed > max) {
    return max;
  }

  return parsed;
}

var HTMLTableCellElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLTableCellElementImpl, _HTMLElementImpl);

  function HTMLTableCellElementImpl() {
    _classCallCheck(this, HTMLTableCellElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLTableCellElementImpl).apply(this, arguments));
  }

  _createClass(HTMLTableCellElementImpl, [{
    key: "colSpan",
    get: function get() {
      return reflectedAttributeClampedToRange(this.getAttribute("colspan"), 1, 1000, 1);
    },
    set: function set(V) {
      this.setAttribute("colspan", String(V));
    }
  }, {
    key: "rowSpan",
    get: function get() {
      return reflectedAttributeClampedToRange(this.getAttribute("rowspan"), 0, 65534, 1);
    },
    set: function set(V) {
      this.setAttribute("rowspan", String(V));
    }
  }, {
    key: "cellIndex",
    get: function get() {
      var tr = closest(this, "tr");

      if (tr === null) {
        return -1;
      }

      return tr.cells.indexOf(this);
    }
  }, {
    key: "scope",
    get: function get() {
      var value = this.getAttribute("scope");

      if (value === null) {
        return "";
      } // Enumerated attribute is matched ASCII-case-insensitively.


      value = asciiLowercase(value);

      if (value === "row" || value === "col" || value === "rowgroup" || value === "colgroup") {
        return value;
      }

      return "";
    },
    set: function set(V) {
      this.setAttribute("scope", V);
    }
  }]);

  return HTMLTableCellElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLTableCellElementImpl
};